export default "__VITE_ASSET__CNx5Mp9E__"